// BonBoZ: trạng thái đóng/mở của panel khách hàng bên phải khung chat.
//
// Chatwoot lưu trạng thái này ở `uiSettings.is_contact_sidebar_open` — tức là
// **trên server, theo tài khoản, dùng chung cho mọi thiết bị**, và mặc định là
// MỞ. Trên máy tính panel nằm cạnh khung chat nên mở sẵn là đúng. Trên điện
// thoại nó là lớp phủ rộng 384px, tức phủ kín màn 360px và chừa 6px ở màn
// 390px: vừa bấm vào một hội thoại là tin nhắn bị che sạch.
//
// Tệ hơn, bấm đóng trên điện thoại sẽ ghi `false` ngược lên server, nên lần sau
// mở máy tính panel cũng biến mất — người dùng không hiểu vì sao.
//
// Ở đây tách đôi: máy tính giữ nguyên hành vi cũ (đọc/ghi server), điện thoại
// dùng một biến chỉ sống trong PHIÊN, mặc định đóng, và không bao giờ chạm tới
// cấu hình dùng chung.
import { computed, ref } from 'vue';
import { useWindowSize } from '@vueuse/core';
import { useUISettings } from 'dashboard/composables/useUISettings';
import wootConstants from 'dashboard/constants/globals';

// Để ngoài hàm: mọi component gọi composable này phải nhìn thấy CÙNG một
// trạng thái, không thì nút ở thanh tiêu đề mở panel mà panel không biết.
const moTrenDienThoai = ref(false);

export function usePanelKhach() {
  const { uiSettings, updateUISettings } = useUISettings();
  const { width } = useWindowSize();

  const laDienThoai = computed(
    () => width.value < wootConstants.SMALL_SCREEN_BREAKPOINT
  );

  const dangMo = computed(() =>
    laDienThoai.value
      ? moTrenDienThoai.value
      : Boolean(uiSettings.value?.is_contact_sidebar_open)
  );

  const dat = mo => {
    if (laDienThoai.value) {
      moTrenDienThoai.value = mo;
      return;
    }
    updateUISettings({ is_contact_sidebar_open: mo });
  };

  const batTat = () => dat(!dangMo.value);

  return { dangMo, dat, batTat, laDienThoai };
}
